import styled from 'styled-components';

const Code02 = styled.span`
    color: ${ ({ color, theme }) => (color ? color : theme.semanticColor.textPrimary) };
    font-family: ${ ({ theme }) => theme.type.monoRegularFont };
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
`;

export default Code02;
